import { pathOr } from 'ramda'

import {
  SEARCH_PARAM_CLIENT_CODE,
  SEARCH_PARAM_CONTRACT_NUMBER,
  SEARCH_PARAM_IATA_CODE,
  SEARCH_PARAM_PROMO_CODE, SEARCH_PARAM_WRONGPROMO_CODE,
} from '../search/constants'

export const searchResults = pathOr({}, ['drupalSettings', 'searchResults'], window)

export const decreasingBanner = drupalSettings?.decreasingBanner

export const businessCodeFilter = pathOr({
  [SEARCH_PARAM_CLIENT_CODE]: 'SCP489754',
  [SEARCH_PARAM_CONTRACT_NUMBER]: 'AI366FR318',
  [SEARCH_PARAM_IATA_CODE]: '',
  [SEARCH_PARAM_PROMO_CODE]: '',
  [SEARCH_PARAM_WRONGPROMO_CODE]: '',
}, ['drupalSettings', 'businessCodeFilter'], window)

export const memberBanner = pathOr({
  text: {
    firstPart: 'Save 5% on your reservation',
    secondPart: 'by becoming an Adagio Hotel member',
  },
  button: 'Become a member',
  isAnonymous: false,
  target: '_self',
  url: '#',
}, ['drupalSettings', 'memberBanner'], window)

export const tid = pathOr('', ['drupalSettings', 'search', 'api', 'tid'], window)
